let container: HTMLElement | null = null;
let id = 0;

function ensureContainer() {
  if (!container) {
    container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.bottom = '0rem';
    container.style.left = '50%';
    container.style.transform = 'translateX(-50%)';
    container.style.zIndex = '9999';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.alignItems = 'center';
    container.style.pointerEvents = 'none';
    container.style.gap = '0rem';
    document.body.appendChild(container);

    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeInOut {
        0% { opacity: 0; transform: translateY(10px); }
        10% { opacity: 1; transform: translateY(-5px); }
        50% { opacity: 1; transform: translateY(-5px); }
        95% { opacity: 1; transform: translateY(-5px);}
        100% { opacity: 0; transform: translateY(20px); }
      }
    `;
    document.head.appendChild(style);
  }
}

function getBackground(severity: string): string {
  switch (severity) {
    case 'normal': return '#2B323B';
    case 'success': return '#0a9728';
    case 'alert': return '#960B1B';
    case 'warning': return '#E3A427';
    case 'info': return '#0C9CB0';
    default: return '#2B323B';
  }
}

function getFontColor(severity: string): string {
  switch (severity) {
    case 'normal': return '#f3f3f3';
    case 'success': return '#f3f3f3';
    case 'alert': return '#f3f3f3';
    case 'warning': return '#f3f3f3';
    case 'info': return '#f3f3f3';
    default: return '#f3f3f3';
  }
}

function notify(message: string, severity: string = 'normal'): void {
  ensureContainer();
  const notif = document.createElement('div');
  notif.textContent = message;
  notif.style.minWidth = '240px';
  notif.style.margin = '0.2rem 0';
  notif.style.padding = '0.8rem';
  notif.style.borderRadius = '0.2rem';
  notif.style.color = '#fff';
  notif.style.fontWeight = '500';
  notif.style.fontSize = '0.7rem';
  notif.style.boxShadow = '0 2px 12px rgba(0,0,0,0.15)';
  notif.style.background = getBackground(severity);
  notif.style.color = getFontColor(severity);
  notif.style.opacity = '1';
  notif.style.animation = 'fadeInOut 3s forwards';
  notif.style.pointerEvents = 'auto';
  notif.style.display = 'flex';
  notif.style.justifyContent = 'center';
  notif.style.alignItems = 'center';
  notif.dataset.id = String(++id);

  container!.appendChild(notif);

  setTimeout(() => {
    notif.remove();
  }, 3000);
}

export const NotificationService = {
  notify
};

// Usage:
// import { NotificationService } from './services/NotificationService';
// NotificationService.notify('Hello world!', 'info');
